import $ from "jquery";
window.jQuery = $;

$(".clerks-sub").on("click", function () {
  let offset = $(".listing-page.clerks").offset().top;
  let headerHeight = $("header").outerHeight();
  $("html, body").animate({ scrollTop: offset - headerHeight }, 1000);
});
